import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";


function Doctors() {

  const navigate = useNavigate();
    const baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_BASE_URL_DEV
        : process.env.REACT_APP_BASE_URL_PROD;


        
          const [doctorData, setDoctorData] = useState([]);
          const doctorExperience = "url('/assets/drbg.jpeg')";

  // doctor

  const backgroundImage = "url('./assets/herocard.png')";
          useEffect(() => {
            const fetchDoctorData = async () => {
              try {
                const response = await fetch(`${baseUrl}/home/getdoctors`);
                if (response.status === 200) {
                  const data = await response.json();
                  // console.log("Fetched DOC data:", data);
                  setDoctorData(data);
                } else {
                  throw new Error("Unable to fetch data");
                }
              } catch (err) {
                console.error(err);
              }
            };
        
            fetchDoctorData();
          }, []);
        
  
  return (
    <div className='pt-20 lg:pt-[140px] pb-20 h-auto relative'>

    <div className="xl:px-[120px] px-5"
    >
      <button onClick={() => navigate(-1)} className="flex gap-4 items-center cursor-pointer w-[100px] ">
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 11.4997H7.82999L12.71 6.61967C13.1 6.22967 13.1 5.58967 12.71 5.19967C12.6175 5.10697 12.5076 5.03342 12.3866 4.98324C12.2656 4.93306 12.136 4.90723 12.005 4.90723C11.874 4.90723 11.7443 4.93306 11.6234 4.98324C11.5024 5.03342 11.3925 5.10697 11.3 5.19967L4.70999 11.7897C4.61728 11.8822 4.54373 11.9921 4.49355 12.113C4.44337 12.234 4.41754 12.3637 4.41754 12.4947C4.41754 12.6256 4.44337 12.7553 4.49355 12.8763C4.54373 12.9973 4.61728 13.1072 4.70999 13.1997L11.3 19.7897C11.3926 19.8823 11.5025 19.9557 11.6234 20.0058C11.7444 20.0559 11.8741 20.0817 12.005 20.0817C12.1359 20.0817 12.2656 20.0559 12.3865 20.0058C12.5075 19.9557 12.6174 19.8823 12.71 19.7897C12.8026 19.6971 12.876 19.5872 12.9261 19.4662C12.9762 19.3453 13.002 19.2156 13.002 19.0847C13.002 18.9537 12.9762 18.8241 12.9261 18.7031C12.876 18.5822 12.8026 18.4723 12.71 18.3797L7.82999 13.4997H19C19.55 13.4997 20 13.0497 20 12.4997C20 11.9497 19.55 11.4997 19 11.4997Z"
            fill="#11485B"
            />
          </svg>
          <p className="text-[#11485B] font-[600]">Back</p>
      </button>
    </div>
    <div
             id="doctor"
             className="relative min-h-[85vh] w-full flex mt-10 items-center justify-center py-5 px-3 xl:px-0"
           >
             <div className="lg:px-[calc((100%-1280px)/2)] h-full w-full relative z-10">
               <div className="flex justify-center">
                 <p className="text-[#234971] tracking-[1px] lg:text-[28px] md:text-[22px] text-[18px] font-[600] text-center mb-6">
                   OUR EXPERIENCED DOCTORS
                 </p>
               </div>
   
               <div className="text-black relative bg-cover xl:justify-between justify-centers overflow-x-auto flex gap-5 px-3  xl:px-0 scroll-container">
                 <div className="flex xl:flex-wrap xl:justify-between w-full gap-10 snap-x snap-mandatory">
                   {doctorData.map((item, index) => (
                     <>
                       <div
                         key={index}
                         className="group lg:w-[320px] my-5 overflow-hidden  lg:h-[400px] w-[280px] h-[380px] rounded-[25px] relative snap-center flex-shrink-0"
                         data-aos="flip-right"
                         data-aos-duration="2000"
                         style={{
                           backgroundImage: backgroundImage,
                           backgroundSize: "cover",
                           backgroundPosition: "center",
                         }}
                       >
                         <div className="flex justify-center h-[80%] ">
                           <img
                             src={item.img}
                             alt=""
                             className="h-[100%] group-hover:w-[40%] w-[100%] transition-all duration-700 group-hover:h-[40%] group-hover:mt-5 group-hover:rounded-b-[25px] cover rounded-t-[25px]"
                           />
                         </div>
   
                         <div className="hidden lg:block absolute w-full text-white group-hover:lg:bottom-[40px] lg:-bottom-[145px] bottom-[100px] group-hover  transition-all duration-1000">
                           <p className="md:text-[20px] text-[18px] font-[600] lg:py-1 text-center w-full">
                             {item.name}
                           </p>
                           <p className="h-[100px] text-center px-5 md:text-[16px] text-[14px] mt-2 md:mt-5">
                             {item.description}
                           </p>
                           <div className="flex mt-5 items-center justify-center flex-col">
                             <div className="flex justify-center relative z-10">
                               <Link to={`/doctors/${encodeURIComponent(item.name)}?id=${item.id}`}>
                                 <button className="flex items-center text-[10px] md:text-[12px] justify-between pr-1 pl-1 lg:w-[100px] h-[30px] w-[100px] bg-[#ffffff] text-[#234971] hover:bg-[#234971] hover:text-[#ffffff] border-2 hover:border-[#ffffff] transition-all duration-300 rounded-[40px] font-[600]">
                                   Read More
                                   <img
                                     src="./assets/hero/more.png"
                                     alt=""
                                     className="bg-[#234971] lg:h-[20px] h-[20px] rounded-full   p-1"
                                   />
                                 </button>
                               </Link>
                             </div>
                           </div>
                         </div>
   
                         <div className=" block lg:hidden absolute w-full h-[200px] text-white group-hover:bottom-[30px] lg: -bottom-[155px] transition-all duration-1000">
                           <p className="md:text-[20px] text-[18px] font-[600] text-center w-full">
                             {item.name}
                           </p>
                           <p className="text-center px-5 md:text-[16px] text-[14px] mt-5 md:mt-5">
                             {item.description}
                           </p>
                           <div className="flex mt-5 items-center justify-center flex-col">
                             <div className="flex justify-center relative z-10">
                               <Link to={`./doctorProfile?id=${item.id}`}>
                                 <button className="flex items-center text-[10px] md:text-[12px] justify-between pr-1 pl-1 lg:w-[100px] h-[30px] w-[100px] bg-[#ffffff] text-[#234971] hover:bg-[#234971] hover:text-[#ffffff] border-2 hover:border-[#ffffff] transition-all duration-300 rounded-[40px] font-[600]">
                                   Read More
                                   <img
                                     src="./assets/hero/more.png"
                                     alt=""
                                     className="bg-[#234971] lg:h-[20px] h-[20px] rounded-full p-1"
                                   />
                                 </button>
                               </Link>
                             </div>
                           </div>
                         </div>
                       </div>
   
                     
                       </>
                   ))}
                 </div>
   
               </div>
   
             </div>
   
   
           </div>
   
   
  </div>  )
}

export default Doctors